<div class="chat-window">
	<div class="chat-title">
		<span class="chat-title-text">MEPhisto</span>
		<button
			(click)="showCheatSheet = !showCheatSheet"
			class="mep-btn-small mep-dialog-title-side_icon"
			matTooltip="{{ _lang('show-cheat-sheet') }}"
		>
			<mat-icon class="mep-btn-small-icon"> help</mat-icon>
		</button>
		@if (showCheatSheet) {
			<div class="cheat-sheet-div mep-custom-dialog-main-window">
				<ul class="cheat-sheet-list">
					{{
						_lang("cheat-sheet.line1")
					}}
					<br />
					<br /><b>
						<li>{{ _lang("cheat-sheet.line2") }}</li>
					</b>
					<ul>
						<li>{{ _lang("cheat-sheet.line3") }}</li>
						<li>{{ _lang("cheat-sheet.line4") }}</li>
						<li>{{ _lang("cheat-sheet.line5") }}</li>
						<li>{{ _lang("cheat-sheet.line6") }}</li>
						<li>{{ _lang("cheat-sheet.line7") }}</li>
					</ul>
					<br />
					<br /><b>
						<li>{{ _lang("cheat-sheet.line8") }}</li>
					</b>
					<ul>
						<li>{{ _lang("cheat-sheet.line9") }}</li>
						<li>{{ _lang("cheat-sheet.line10") }}</li>
						<li>{{ _lang("cheat-sheet.line11") }}</li>
						<li>{{ _lang("cheat-sheet.line12") }}</li>
						<li>{{ _lang("cheat-sheet.line13") }}</li>
					</ul>
					<br />
					<br /><b>
						<li>{{ _lang("cheat-sheet.line14") }}</li>
					</b>
					<ul>
						<li>{{ _lang("cheat-sheet.line15") }}</li>
						<li>{{ _lang("cheat-sheet.line16") }}</li>
						<li>{{ _lang("cheat-sheet.line17") }}</li>
						<li>{{ _lang("cheat-sheet.line18") }}</li>
						<li>{{ _lang("cheat-sheet.line19") }}</li>
					</ul>
				</ul>
			</div>
		}
	</div>
	<div #chatMessagesWindow class="chat-messages-window">
		@for (message of messages; track message) {
			<app-chat-message
				[class.human-message-bubble]="message.sender === 'Du'"
				[class.bot-message-bubble]="message.sender === 'Mephisto'"
				[message]="message"
				(copyRequest)="onCopyPrompt($event.text, $event.event)"
			>
			</app-chat-message>
		}
	</div>

	@if (showFlyingText) {
		<div class="flying-text" [style.left.px]="flyingTextPosition.x" [style.top.px]="flyingTextPosition.y">
			{{ flyingText }}
		</div>
	}

	<div class="input-row">
		<div class="input-bar">
			<textarea
				#inputTextArea
				class="chat-input"
				placeholder="{{ _lang('input-textarea-placeholder') }}"
				(input)="adjustTextAreaHeight()"
				[(ngModel)]="inputText"
				(keydown)="checkEnter($event)"
			></textarea>
			<button mat-button [matMenuTriggerFor]="optionsMenu" #optionsTrigger="matMenuTrigger" class="options-btn">
				{{ _lang("advanced-options") }}
				<mat-icon>
					{{ optionsTrigger.menuOpen ? "expand_less" : "expand_more" }}
				</mat-icon>
			</button>
			<button class="chat-button-big" (click)="sendMessage(inputText, 'Du')">
				<mat-icon class="chat-button-icon">send</mat-icon>
			</button>
		</div>
		<mat-menu #optionsMenu="matMenu" class="options-menu" [overlapTrigger]="false">
			<button mat-menu-item (click)="$event.stopPropagation()">
				<mat-checkbox [(ngModel)]="ignoreCapa" matTooltip="{{ _lang('checkbox-ignore-capa-tooltip') }}">
					{{ _lang("ignore-capa-text") }}
				</mat-checkbox>
			</button>
			<button mat-menu-item (click)="$event.stopPropagation()">
				<mat-checkbox [(ngModel)]="crossBusinessUnitSearch" matTooltip="{{ _lang('checkbox-cross-bu-tooltip') }}">
					{{ _lang("cross-bu-text") }}
				</mat-checkbox>
			</button>
			<button mat-menu-item class="availability-item" (click)="$event.stopPropagation()">
				<span matTooltip="{{ _lang('input-minimum-availability-tooltip') }}">min. Availability: </span>
				<input type="number" min="1" max="100" [(ngModel)]="minimumAvailability" />
			</button>
			<button
				mat-menu-item
				(click)="openLlmResponsePanel()"
				matTooltip="{{ _lang('llm-response.tooltip') }}"
				[disabled]="!activeLlmResponse"
			>
				{{ _lang("llm-response.button") }}
			</button>
		</mat-menu>
	</div>
	@if (showLlmResponse && activeLlmResponse) {
		<div class="llm-response-panel-inside" @llmPanel>
			<div class="llm-response-panel-header">
				<span>{{ _lang("llm-response.header") }}</span>
				<button mat-icon-button (click)="openLlmResponsePanel()" class="close-btn"><mat-icon>close</mat-icon></button>
			</div>
			<pre class="llm-response-panel-content">{{ activeLlmResponse }}</pre>
		</div>
	}
</div>
